import React, { useState } from "react";
import { Modal } from "@wantable/Shared/Components";
import LoginForm from "../LoginForm";
import SignUpForm from "../SignUpForm/SignUpForm";
import ResetPasswordForm from "../ResetPasswordForm/ResetPasswordForm";
import ForgotPasswordForm from "../ForgotPasswordForm/ForgotPasswordForm";
import { ModalType}  from "../types";

export interface ISignUpLoginModalProps {
  modalType: ModalType;
  onAfterLogin?: () => void;
}

const SignUpLoginModal = ({
  modalType,
  onAfterLogin = () => {},
}: ISignUpLoginModalProps) => {
  const [modal, setModal] = useState<ModalType>(modalType);
  return (
    <div>
      {modal === "login" && (
        <Modal
          contentPosition="center"
          onClose={() => {
            setModal(null);
          }}
        >
          <LoginForm
            variantLabel="login"
            onClose={() => {
              setModal(null);
            }}
            onSwitchModal={(modal: ModalType) => setModal(modal)}
            onAfterLogin={onAfterLogin}
          />
        </Modal>
      )}

      {modal === "signup" && (
        <Modal
          contentPosition="center"
          onClose={() => {
            setModal(null);
          }}
        >
          <SignUpForm
            variantLabel="signup"
            onClose={() => {
              setModal(null);
            }}
            onSwitchModal={(modal: ModalType) => setModal(modal)}
            onAfterLogin={onAfterLogin}
          />
        </Modal>
      )}

      {modal === "forgot" && (
        <Modal
          contentPosition="center"
          onClose={() => {
            setModal(null);
          }}
        >
          <ForgotPasswordForm
            onClose={() => {
              setModal(null);
            }}
            onSwitchModal={(modal: ModalType) => setModal(modal)}
          />
        </Modal>
      )}

      {modal === "reset" && (
        <Modal
          contentPosition="center"
          onClose={() => {
            setModal(null);
          }}
        >
          <ResetPasswordForm
            onClose={() => {
              setModal(null);
            }}
            onAfterLogin={onAfterLogin}
          />
        </Modal>
      )}
    </div>
  );
};

export default SignUpLoginModal;
